import {Component, OnInit} from '@angular/core';
import {RuleService} from 'src/app/services/rule.service';
import {AccountService} from 'src/app/services/account.service';
import {CategoryService} from 'src/app/services/category.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {PageEvent} from '@angular/material/paginator';
import {Sort} from '@angular/material/sort';
import {NotificationService} from '../../../services/notification.service';
import {RuleDTO} from '../../../model/ruleDTO';

@Component({
  selector: 'app-rule',
  templateUrl: './rule.component.html',
})
export class RuleComponent implements OnInit {

  content: RuleDTO[] = [];
  totalElements = 0;
  sort;

  pageSize = 1000;
  pageSizeOptions: number[] = [25, 50, 100, 250, 500, 1000];
  pageEvent: PageEvent = new PageEvent(); // MatPaginator Output

  constructor(private ruleService: RuleService,
              private accountService: AccountService,
              private categoryService: CategoryService,
              private router: Router,
              private notificationService: NotificationService,
              public translate: TranslateService) {
    translate.use('nl');
  }

  ngOnInit() {
    this.sort = {column: 'subcategory.name', dir: 'asc'};
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.getPage();
  }

  updatePage($event) {
    this.pageEvent = $event;
    this.getPage();
    return $event;
  }

  getPage() {
    this.ruleService.getAll(this.pageEvent.pageIndex, this.pageEvent.pageSize, this.sort.column, this.sort.dir).subscribe(page => {
      this.content = page.content;
      this.totalElements = page.totalElements;
    });
  }

  sortPage($event: Sort) {
    this.sort.column = $event.active;
    this.sort.dir = $event.direction;
    this.getPage();
  }

  addRule() {
    this.router.navigate(['/regels/toevoegen']);
  }

  delete(id) {
    this.notificationService.confirm({header: 'Regel verwijderen', ok: 'Verwijderen'}).then(() => {
      this.ruleService.delete(id).subscribe(() => {
        this.getPage();
      });
    });
  }
}
